import * as t from 'io-ts';

import type { SelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

const DateTypesC = t.union([
    t.literal('date'),
    t.literal('year'),
    t.literal('month'),
    t.literal('week'),
]);

type DateTypes = t.TypeOf<typeof DateTypesC>;

export interface DateTypeSettingDefinition extends SelectDefinition {
    key: 'DATE_TYPE';
    value: DateTypes;
}

const definition: DateTypeSettingDefinition = {
    key: 'DATE_TYPE',
    type: 'Select',
    label: 'Date type',
    options: [
        { key: 'date', label: 'date' },
        { key: 'year', label: 'year' },
        { key: 'month', label: 'month' },
        { key: 'week', label: 'week' },
    ],
    value: 'date',
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, DateTypesC);

export const codec = specSettingsInterface.input;

export const DateTypeSettingDefinition = define({
    key: 'DATE_TYPE',
    label: 'dateType',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.dateType),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.dateType),
});
